import React from 'react';
import { Tag } from 'antd';
import { ButtonToolTip } from '../../../components';
import { color } from '../../../resources';
import { getRowStockState } from '../claim-product/func/stockHelper';
import { STOCK_ROW_STATE, STOCK_STATE_LABEL } from '../claim-product/resource/stockConst';

export const stockAvailabilityColumn = (
  stockMap = {},
  selectedByItem = {},
  { getStockRecord = (record) => record, showFilters = true } = {},
) => ({
  title: 'สต็อกคงเหลือ',
  dataIndex: 'itemCode',
  key: 'stockAvailable',
  width: 120,
  filters: showFilters
    ? [
        STOCK_ROW_STATE.OK,
        STOCK_ROW_STATE.OUT_OF_STOCK,
        STOCK_ROW_STATE.OVER_SELECTED,
        STOCK_ROW_STATE.UNKNOWN,
        STOCK_ROW_STATE.STALE,
        STOCK_ROW_STATE.EXCLUDED,
      ].map((value) => ({ text: STOCK_STATE_LABEL[value], value }))
    : undefined,
  onFilter: (value, record) =>
    getRowStockState({ record: getStockRecord(record), stockMap, selectedByItem }).state === value,
  render: (_, record) => {
    const { state, available, selected, reason } = getRowStockState({
      record: getStockRecord(record),
      stockMap,
      selectedByItem,
    });
    if (state === STOCK_ROW_STATE.EXCLUDED) {
      return <span style={{ color: color.grey }}>-</span>;
    }
    if (state === STOCK_ROW_STATE.UNKNOWN || state === STOCK_ROW_STATE.STALE) {
      return (
        <ButtonToolTip toolTip={reason} placement="topLeft">
          <Tag color={color.orangeTheme}>ไม่มีข้อมูล</Tag>
        </ButtonToolTip>
      );
    }
    const stock = stockMap?.[record?.itemCode];
    const isProblem = state !== STOCK_ROW_STATE.OK;
    return (
      <div>
        <Tag color={isProblem ? color.red3 : color.line}>
          {`เหลือ ${available}${selected > 0 ? ` / เลือก ${selected}` : ''}`}
        </Tag>
        <div style={{ fontSize: 11, color: color.grey }}>
          {`บริษัท ${stock?.company ?? '-'} : ${stock?.availableQty ?? 0}`}
        </div>
      </div>
    );
  },
});
